module.exports = __webpack_public_path__ + "static/media/heartsColored.628272f2.svg";